export default "__VITE_ASSET__Bw90sHZM__"